module.exports = __webpack_public_path__ + "img/visa.1beac54.png";